import { render } from "./CRADashboard.vue?vue&type=template&id=7aade550"
import script from "./CRADashboard.vue?vue&type=script&lang=js"
export * from "./CRADashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__